import React from "react";
import Nabvar from "../../common/Nabvar";
import Sidebar from "../../common/Sidebar";
import Kaorder from "./KaOrder";

export default function Ka_order() {

  return (
    <>
      <section>
        <Sidebar />
        <Nabvar />
      </section>
      <section>
        <Kaorder />
      </section>
    </>
  );
}
